import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ValidationHandlerService, TranslatedToastrService, EditComponent, BaseComponent, LanguageService, SearchData, DataTableRequest, OneColumnSearchData, FileResponse } from 'lib/Vestra.shared';
import { firstValueFrom } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { CoreService, MessageListModel } from 'src/app/services/api-services';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { NotificationSentMessageEditComponent } from '../notification-sent-message-edit/notification-sent-message-edit.component';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ADTSettings } from 'angular-datatables/src/models/settings';

@Component({
    selector: 'app-notification-sent-message-list',
    templateUrl: './notification-sent-message-list.component.html',
    styleUrls: ['./notification-sent-message-list.component.scss'],
})
export class NotificationSentMessageListComponent extends BaseComponent implements OnInit, AfterViewInit {
    @ViewChild('actionsRef') actionsRef: TemplateRef<EditComponent>;
    constructor(
        protected override validationHandlerService: ValidationHandlerService,
        private translatedToastrService: TranslatedToastrService,
        private translateService: TranslateService,
        protected override modalService: BsModalService,
        private coreService: CoreService,
        protected override spinnerService: NgxSpinnerService,
        protected override languageService: LanguageService
    ) {
        super(spinnerService, modalService, validationHandlerService, translateService, languageService);
    }

    public override getDtOptions() {
        let self = this;
        this.languageUrl = this.languageService.getTranslationUrl();

        const res: ADTSettings = {
            serverSide: true,
            processing: false,
            pageLength: 20,
            lengthChange: false,
            responsive: {
                details: {
                    type: 'column',
                    target: -1,
                },
            },
            searching: false,
            destroy: true,
            language: {
                url: this.languageUrl,
            },
            ajax: (dataTablesParams: any, callback: any) => {
                const searchData: OneColumnSearchData = {
                    propertyValue: this.searchValue,
                };

                for (let order of dataTablesParams.order) {
                    order.name = dataTablesParams.columns[order.column]?.data;
                }

                const model: DataTableRequest = {
                    draw: dataTablesParams.draw,
                    start: dataTablesParams.start,
                    length: dataTablesParams.length,
                    order: dataTablesParams.order,
                    search: searchData,
                    columns: this.transformToColumnData(this.dtOptions.columns),
                };

                this.datatableRequest = model;

                this.handleSpinner(firstValueFrom(this.coreService.getMessageListDataSource(model)))
                    .then(res => {
                        console.log(res);
                        callback(this.getTableData(res));
                        return Promise.resolve(res);
                    })
                    .catch((err: HttpErrorResponse) => {
                        this.validationHandlerService.handleServerError(err);
                        callback(this.getEmptyTableData());
                    });
            },
            columns: [
                {
                    data: 'id',
                    title: 'common.id',
                    searchable: false,
                    orderable: true,
                },
                {
                    data: 'fullName',
                    title: 'common.name',
                    searchable: false,
                    orderable: true,
                },
                {
                    data: 'from',
                    title: 'notification.message_from',
                    searchable: false,
                    orderable: true,
                },
                {
                    data: 'sentType',
                    title: 'notification.message_sent_type_title',
                    searchable: false,
                    orderable: true,
                    render: function (data) {
                        let translateKey = 'notification.message_sent_type_' + self.toSnakeCase(data);
                        return self.translateService.instant(translateKey);
                    },
                },
                {
                    data: 'subject',
                    title: 'common.subject',
                    searchable: false,
                    orderable: true,
                },
                {
                    data: 'sentDate',
                    title: 'notification.message_sent_date',
                    searchable: false,
                    orderable: true,
                },
                {
                    title: 'common.actions',
                    data: null,
                    searchable: false,
                    orderable: false,
                    defaultContent: '',
                    ngTemplateRef: {
                        ref: this.actionsRef,
                        context: {
                            captureEvents: this.onEditItem.bind(this),
                        },
                    },
                    responsivePriority: 1,
                },
                {
                    data: '',
                    orderable: false,
                    responsivePriority: 1,
                    render: function (data) {
                        return '';
                    },
                },
            ],
            columnDefs: [
                {
                    targets: '_all',
                    visible: true,
                },
                {
                    className: 'details-icon dtr-control',
                    orderable: false,
                    target: -1,
                },
            ],
        };

        return res;
    }

    public ngOnInit(): void {
        this.dataTableOnInit();
    }

    public ngAfterViewInit() {
        this.dataTableAfterViewInit();
    }

    public ngOnDestroy() {
        this.dataTableOnDestroy();
    }
    public onSearch(event: string): void {
        this.searchValue = event;
        this.refreshDataTable();
    }

    public onAddItem() {
        this.openEditModalWithComponent(null);
    }

    public onEditItem(event: any) {
        this.openEditModalWithComponent(event.data);
    }

    public openEditModalWithComponent(item: MessageListModel) {
        let modalOptions: ModalOptions = this.getDefaultModalOptions('common.message', item);

        let bsModalRef: BsModalRef = this.modalService.show(NotificationSentMessageEditComponent, modalOptions);
        bsModalRef.onHide.subscribe((reason: string | any) => {
            this.refreshDataTable();
        });
    }
    public toSnakeCase(str: string): string {
        return str
            .replace(/([A-Z])/g, '_$1')
            .toLowerCase()
            .replace(/^_/, '');
    }
}
